import { useEffect, useState } from "react";
import { Cretae_role, get_all_role } from "services/auth/permission";
import PropTypes from 'prop-types';
import { PERMISSIONS } from "pages/AuthorityRole/defineroles";
import Swal from 'sweetalert2';
import { t } from 'i18next';

Modal_AddRole.propTypes = {
    onSubmit: PropTypes.func,
};

Modal_AddRole.defaultProps = {
    onSubmit: null,
}

function Modal_AddRole(props) {
    const { onSubmit, dismiss } = props;
    const [screenCodes, set_screenCodes] = useState({});
    const [featureCodes, set_featureCodes] = useState({});
    const [errors, setErrors] = useState({});

    const handleCheck = (event, name, item, root1, root2) => {

        const value = event.target.checked;

        if (item === "item") {
            handleItem(value, name);
        } else if (item === "path") {
            handlePath(value, name, root1);
        } else if (item === "function") {
            handleFunction(value, name, root1, root2);
        }
        // console.log(event.target.checked, name);
    }

    const handleItem = (value, name) => {
        if (value) {
            let data = Object.assign({}, screenCodes);
            data = { ...data, [name]: [] };
            set_screenCodes(data);
            if (!(name in screenCodes)) {

                let data = Object.assign({}, screenCodes);
                data = { ...data, [name]: [] };

                let newFeatureCodes = Object.assign({}, featureCodes);

                PERMISSIONS.screenCodes[name].forEach(item => {
                    data[name] = [...data[name], item];
                    PERMISSIONS.featureCodes[item].forEach(item2 => {
                        if (!(item in newFeatureCodes)) {
                            newFeatureCodes = { ...newFeatureCodes, [item]: [item2] };
                        } else {
                            newFeatureCodes[item] = [...newFeatureCodes[item], item2];
                        }
                    });
                });
                set_featureCodes(newFeatureCodes);
                set_screenCodes(data);
            }
        } else {
            let data = Object.assign({}, screenCodes);

            let newFeatureCodes = Object.assign({}, featureCodes);
            for (let i = 0; i < data[name].length; i++) {
                delete newFeatureCodes[data[name][i]];
            }
            set_featureCodes(newFeatureCodes);

            delete data[name];
            set_screenCodes(data);
        }
    }

    const handlePath = (value, name, root) => {
        if (value) {
            if (!(root in screenCodes)) {
                let data = Object.assign({}, screenCodes);
                data = { ...data, [root]: [name] };
                set_screenCodes(data);

            } else {
                let data = Object.assign({}, screenCodes);
                if (!data[root]?.includes(name)) {
                    data[root] = [...data[root], name];
                    set_screenCodes(data);
                }
            }

            if (!(name in featureCodes)) {

                let newFeatureCodes = Object.assign({}, featureCodes);
                newFeatureCodes[name] = PERMISSIONS.featureCodes[name];
                set_featureCodes(newFeatureCodes);
            }
        } else {

            if (screenCodes[root]?.includes(name)) {
                let data = Object.assign({}, screenCodes);
                data[root] = data[root].filter(item => item !== name);
                set_screenCodes(data);
            }

            let newFeatureCodes = Object.assign({}, featureCodes);
            delete newFeatureCodes[name];
            set_featureCodes(newFeatureCodes);
        }
    }

    const handleFunction = (value, name, root1, root2) => {

        let newFeatureCodes = Object.assign({}, featureCodes);

        if (value) {
            if (!(root1 in newFeatureCodes)) {
                newFeatureCodes = { ...newFeatureCodes, [root1]: [name] };
            } else {
                newFeatureCodes[root1] = [...newFeatureCodes[root1], name];
            }

            if (!(root2 in screenCodes)) {
                let data = Object.assign({}, screenCodes);
                data = { ...data, [root2]: [root1] };
                set_screenCodes(data);
            }
            if (root2 in screenCodes && !(root1 in screenCodes[root2])) {
                let data = Object.assign({}, screenCodes);
                if (!data[root2]?.includes(root1)) {
                    data[root2] = [...data[root2], root1];
                    set_screenCodes(data);
                }
            }
        }
        else {
            newFeatureCodes[root1] = newFeatureCodes[root1].filter(item => item !== name);
        }

        set_featureCodes(newFeatureCodes);
    }

    const handleAddRole = async () => {

        const nameRole = document.getElementById("name").value;

        if (nameRole == "") {
            setErrors({ name: "Bạn chưa nhập tên vai trò !" });
            return;
        }

        let resultSceenCodes = "";
        Object.keys(screenCodes).map((key, index) => {
            if (index < Object.keys(screenCodes).length - 1) {
                resultSceenCodes += `${key}:${screenCodes[key].join(',')};`;
            }
            else {
                resultSceenCodes += `${key}:${screenCodes[key].join(',')}`;
            }
        });


        let resultfeatureCodes = "";

        Object.keys(featureCodes).map((key, index) => {
            if (index < Object.keys(featureCodes).length - 1) {
                resultfeatureCodes += `${key}:${featureCodes[key].join(',')};`;
            }
            else {
                resultfeatureCodes += `${key}:${featureCodes[key].join(',')}`;
            }
        });

        const res = await Cretae_role({ name: nameRole, screenCodes: resultSceenCodes, featureCodes: resultfeatureCodes });

        await Swal.fire({
            title: t('Notification'),
            text: res.data.message,
            icon: 'warning',
            confirmButtonText: t('Yes'),
            customClass: {
                confirmButton: 'btn btn-danger font-weight-bolder',
                cancelButton: 'btn btn-light font-weight-bolder',
            }
        })
        onSubmit();
        dismiss();
    }

    return <div className="modal-content">
        <div className="px-5 py-5 modal-header">
            <div className="modal-title h4">Thêm vai trò</div>
            <div className="btn btn-xs btn-icon btn-light btn-hover-secondary cursor-pointer" onClick={() => dismiss()}>
                <i className="fa fa-times"></i>
            </div>
        </div>
        <div className="modal-body">
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group mb-3">
                            <div className="d-flex justify-content-between align-items-start">
                                <label className="font-weight-bolder">Tên vai trò <span className="text-danger">(*)</span></label>
                            </div>
                            <div className="w-100">
                                <div>
                                    <input className="form-control" type="text" name="name" id="name" placeholder="Tên vai trò"
                                        onChange={(e) => {
                                            if (e.target.value !== "") {
                                                setErrors({ name: "" });
                                            } else {
                                                setErrors({ name: "Bạn chưa nhập tên vai trò !" });
                                            }
                                        }}
                                    />
                                    {
                                        errors.name && <div className="fv-plugins-message-container">
                                            <div className="fv-help-block">{errors.name}</div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <div className="p-2">
                            <div className="mt-3">
                                <div className="form-group mb-3">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <label htmlFor="" className="font-weight-bolder">PHÂN QUYỀN THEO MÀN HÌNH</label>
                                    </div>
                                    <div className="row">
                                        {Object.keys(PERMISSIONS.screenCodes).map((key, index) => {
                                            return <div key={index} className="col-xl-4 col-lg-6 pb-2 border-top border-bottom border-left border-right">
                                                <div className="checkbox-list mt-2">
                                                    <div>
                                                        <label className="checkbox mb-0 checkbox-rounded switch-primary mr-4">
                                                            <input type="checkbox"
                                                                onChange={(e) => handleCheck(e, key, "item")}
                                                                checked={!!(key in screenCodes)}
                                                            />
                                                            <span className="mr-2"></span>
                                                            <div className="font-weight-bolder">{PERMISSIONS.name[key]}</div>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="pl-10 row">
                                                    {PERMISSIONS.screenCodes[key].map((item2, index2) => {
                                                        return <div key={index2} className="col-12">
                                                            <div className="checkbox-list mt-2">
                                                                <div>
                                                                    <label className="checkbox mb-0 checkbox-rounded switch-primary mr-4">
                                                                        <input type="checkbox" name={`switch_${item2}`}
                                                                            onChange={(e) => handleCheck(e, item2, "path", key)}
                                                                            checked={!!(screenCodes[key]?.includes(item2))}
                                                                        />
                                                                        <span className="mr-2"></span>
                                                                        {PERMISSIONS.name[item2]}
                                                                    </label>
                                                                </div>
                                                                {
                                                                    PERMISSIONS.featureCodes[item2].map((item3, index3) => {
                                                                        return (
                                                                            <div key={index3} className="col-12">
                                                                                <div className="checkbox-list mt-2">
                                                                                    <div>
                                                                                        <label className="checkbox mb-0 checkbox-rounded switch-primary mr-4">
                                                                                            <input type="checkbox" name={`switch_${item3}`}
                                                                                                onChange={(e) => handleCheck(e, item3, "function", item2, key)}
                                                                                                checked={!!(featureCodes[item2]?.includes(item3)) && !!screenCodes[key]?.includes(item2)}
                                                                                            />
                                                                                            <span className="mr-2"></span>
                                                                                            {PERMISSIONS.name[item3]}
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    })}
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="separator separator-dashed mb-4"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="bg-white position-sticky sticky-bottom modal-footer">
            <div className="w-100 d-flex row gap-3">
                <button type="button" className="font-weight-bold flex-grow-1 col btn btn-secondary" onClick={() => dismiss()}>Hủy bỏ</button>
                <button type="submit" className="font-weight-bold flex-grow-1 col btn btn-primary" onClick={handleAddRole}>Thêm mới</button>
            </div>
        </div>
    </div>
};

export default Modal_AddRole;
